<template>
  <div class="col-xs-12" style="padding: 0px;">
    <div style="float: right;margin-right: -10px;margin-bottom: 10px;margin-top: -10px;" class="col-xs-6">
      <img ref="qrCodeImg"  v-if="showQrCode" style="width: 20px;height:20px; float: right;margin-right: 4px;background:green;display:none;" />
      <button v-if="showQrCode" style="width: 100px;float: right;margin-right: 4px;" class="btn btn-primary esma_btn_form btn-xs" @click="scannQRCode">QR コード</button>
      <input v-if="showQrCode"  type="file" capture="camera" id="camera" ref ="camera" style="display:none"/>
      <div class="input-group" style="float: right; display: inline-flex;">
        <input v-if="isShowInputBox" autofocus ref="barcodeInput" 
          v-on:keyup="onKeyUp('UP',$event.target.value, $event)"
          style="width: 200px;float: right;" type="input" class="form-control" placeholder="バーコード入力">
        <div class="input-group-btn hg_dropdown">
        </div>
        <!-- /btn-group -->
      </div>
      <!-- /input-group -->
      <button :style="buttonStyle" v-if="isShowClearButton" class="btn btn-primary esma_btn_form btn-xs" @click="clearBarcode">検索クリア</button>
    </div>
  </div>
</template>
<script>
/*
 v-on:keyup.enter="onBarcodeEnter($event.target.value)" 
        v-on:keypress="onKeyUp('PRESS',$event.target.value, $event)"
        v-on:keydown="onKeyUp('DOWN',$event.target.value, $event)"
*/
import Vue from 'vue'
import { bus } from '@/libs/bus'
export default {
  components: {
    // dropdown
  },
  data() {
    return {
      input_buff:"",
      decoder :false,
      local_page_container_size:false
    }
  },
  computed: {
    buttonStyle(){
        this.local_page_container_size = parseInt(localStorage.getItem("pageContainerSize"));
        var s = 5;

        if(this.local_page_container_size < 1120){
          s = -30;
        }else if(this.local_page_container_size < 1320){
          s = -15;
        }else if(this.local_page_container_size < 1520){
          s = 0;
        }else if(this.local_page_container_size > 1420){
          s = 15;
        }
        console.log("buttonStyle "+this.local_page_container_size+" > " + 0)

        return "width: 100px;float: right;margin-right: " + s + "px;"
    },
    isShowInputBox(){
      return this.$props.showinputbox ;
    },
    isShowClearButton(){
      return this.$props.showclearbutton ;
    },

  showQrCode (){
    // TODO: Also test if is not the QR browsers
    return this.isIOS();
  }
},
  methods: {
    isIOS(){
      return ['iPad', 'iPhone', 'iPod'].indexOf(navigator.platform) >= 0;
    },
    scannQRCode(){
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      var camera = this.$refs.camera;
      camera.click()
      camera.addEventListener('change', (event) => {
        this.$refs.barcodeInput.placeholder = "QRコード processing ... "
          console.log("camera changed")
          if (event.target && event.target.files.length > 0) {
          console.log("camera changed",event.target.files.length)
              var img =  this.$refs.qrCodeImg
              this.decoder.onmessage = (event) =>{
                  if (event.data.length > 0) {
                    var qrcode = event.data[0][2]
                    console.log("qrcode",qrcode)
                    this.$refs.barcodeInput.placeholder = "Found " + qrcode
                    this.onBarcodeEnter(qrcode,qrcode)
                  }else{
                    this.$refs.barcodeInput.placeholder = "QRコード not found "
                  }
                  setTimeout(()=>{
                      this.$refs.barcodeInput.placeholder = "バーコード入力"
                    },2000)
              }
              setTimeout(()=> {
                  img.src = URL.createObjectURL(event.target.files[0]);
                  setTimeout(()=> {
                      ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
                      var imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                    this.decoder.postMessage(imgData);
                  }, 300)
              }, 30)
          }else{
            this.$refs.barcodeInput.placeholder = "バーコード入力"
          }
      });
    },
    onSubmit(ev) {
      ev.preventDefault();
      return false
    },
    clearBarcode() {
      // console.log("barcode clear");
      bus.$emit("onSearchClear","");

      this.$emit("onBarcodeClear", "");
      if(this.isShowInputBox){
        this.$refs.barcodeInput.value = ""
        this.$refs.barcodeInput.focus()
      }
      this.input_buff ="";
    },
    onKeyUp(mode, value, event) {
      if(this.isIOS()==false){
        if(event.key=="Enter"){
          this.onBarcodeEnter(value,"")
          this.input_buff = ""
          this.$refs.barcodeInput.value = ""
        }
        return;
      }
      if(mode == "UP")
      // console.log("onKeyUp", mode, value, event)
      if(event.key=="Backspace"){
        event.preventDefault()
        this.$refs.barcodeInput.value = this.input_buff
      }else if(event.key=="Enter"){
        this.onBarcodeEnter(value,this.input_buff)
        this.input_buff = ""
        this.$refs.barcodeInput.value = ""
      }else{
        this.input_buff += event.key
      }
    },
    onBarcodeEnter(val,buff) {
      console.log("============ onBarcodeEnter  component =================",buff,this.$refs.barcodeInput)
      if(this.isIOS()){
        this.$emit("onBarcodeInputed", { value: buff });
      }else{
        this.$emit("onBarcodeInputed", { value: this.$refs.barcodeInput.value});
      }
    }
  },mounted(){
        bus.$on("BarcodeClearInitiated",() =>{
          this.$refs.barcodeInput.focus()
        });
        bus.$on("barcodeTestOne",(data) =>{
          console.log("barcodeTestOne",data)
          this.input_buff = data
          if(typeof this.$refs != "undefined" && typeof this.$refs.barcodeInput != "undefined")
          this.$refs.barcodeInput.value = data
        });
        this.decoder = new Worker("static/decoder.min.js");
  },
  beforeDestroy () {
    bus.$off("BarcodeClearInitiated")
  },
  props:{
    showinputbox: {
      type: Boolean
    },
    showclearbutton: {
      type: Boolean,
      default:true
    },
  }
}
</script>
<style scoped>
.form-control {
  height: 24px;
}
</style>


// WEBPACK FOOTER //
// barcode-input.vue?a964f73e